import { render, staticRenderFns } from "./MemberTypeMaintenance.vue?vue&type=template&id=95da7956"
import script from "./MemberTypeMaintenance.vue?vue&type=script&lang=ts"
export * from "./MemberTypeMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports